import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseResetPassword2Component } from './reset-password-2.component';

const routes = [
    {
        path     : 'pages/auth/reset-password-2',
        component: FuseResetPassword2Component
    }
];

@NgModule({
    declarations: [
        FuseResetPassword2Component
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class ResetPassword2Module
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/authentication/reset-password-2/reset-password-2.module.ts